import api from "!../../ckeditor5-build-classic/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../ckeditor5-build-classic/node_modules/css-loader/dist/cjs.js!../../ckeditor5-build-classic/node_modules/postcss-loader/dist/cjs.js??ref--5-2!./blockquote.css";

var options = {"injectType":"singletonStyleTag","attributes":{"data-cke":true}};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



export default content.locals || {};